!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready

   $('.submenu ul li.custom-collection-menu').each(function(idx, ele){
    $(ele).parents('li.level-1').addClass('st-menu-style');
  });

   $("#app-body").click(function(){
     if( $(".header-lang-menu").hasClass("active")){
     $(".header-lang-menu").removeClass("active");
       };
    });
  $(document).click(function(){
 $(".header-lang-menu").removeClass("active");
 
});
  $(".header-lang-a").click(function(event){
event.stopPropagation();
});
$(".header-lang-a").click(
function(){
  if( $(".header-lang-menu").hasClass("active")){

      $(".header-lang-menu").removeClass("active");
  $("body").removeClass("active1");

}else{

     $(".header-lang-menu").addClass("active");
     $("body").addClass("active1")

};
 

});
 
}(jQuery);